import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto } from '../../../models/adapters/PlaceActivationAdapter';
import { fromDto } from '../../../models/adapters/PlaceActivationResultAdapter';
import PlaceActivationResult from '../../../models/interfaces/PlaceActivationResult';
import { activatePlace, ActivatePlaceActionType, placeActivationFailed, placeActivationFinished } from '../../actions/registration/activatePlace';
import getPublicResponse from '../getPublicResponse';

function* activatePlaceSaga({ payload }: ActivatePlaceActionType) {
  const timestamp = moment();
  const { placeActivationData, token } = payload;
  const placeActivationDto = toDto(placeActivationData);
  const response = yield getPublicResponse(PublicServerPlaceEvent.activatePlace, {
    placeActivationDto,
    token,
  });
  const { placeActivationResult, error } = response;
  if (error || placeActivationResult !== PlaceActivationResult.successful) {
    const action = placeActivationFailed({
      placeActivationResult: fromDto(placeActivationResult) || PlaceActivationResult.failed,
      timestamp,
    });
    yield put(action);
  } else {
    const action = placeActivationFinished({
      placeActivationResult: fromDto(placeActivationResult),
      timestamp,
    });
    yield put(action);
  }
}

export default function* watchActivatePlaceSaga() {
  yield takeEvery(activatePlace, activatePlaceSaga);
}
